export default defineNuxtRouteMiddleware((to) => {
  if (!to.matched.length) {
    return navigateTo('/', {
      redirectCode: 301,
      replace: true,
      external: true,
    });
  }
});
